/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CmKatuze { 
    ciselnaRada: number;
    katastralniPracovisteKod: number;
    katastralniPracovisteNazev: string;
    krajKod: number;
    krajNazev: string;
    kuKod: number;
    kuNazev: string;
    mapa: string;
    obecKod: number;
    obecNazev: string;
    okresKod: number;
    okresNazev: string;
    platnostDo?: string;
    platnostOd: string;
}

